<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__heading-area">
          <h1 class="l-top-navi__heading-text" [innerHTML]="'label.searchFlight.title' | staticMsg"></h1>
        </div>
        <!-- [ヘッダー下メニュー ボタンエリア] -->
        <ng-container *ngIf="!isPc">
          <div class="l-top-navi__function-area">
            <div class="l-top-navi__function-item" *ngIf="!loginStatus">
              <button
                id="search-flight-sub-header-button-5"
                class="l-top-navi__function-btn l-top-navi__function-btn--history"
                (throttleClick$)="clickHistory()"
                aswThrottleClick
              >
                <span class="u-visually-hidden" [innerHTML]="'label.searchHistory.title' | staticMsg"></span>
              </button>
            </div>
            <div class="l-top-navi__function-item" *ngIf="!loginStatus">
              <button
                id="search-flight-sub-header-button-6"
                class="l-top-navi__function-btn l-top-navi__function-btn--favorites"
                (throttleClick$)="clickFavorite()"
                aswThrottleClick
              >
                <span class="u-visually-hidden" [innerHTML]="'label.Favorite.title' | staticMsg"></span>
              </button>
            </div>
          </div>
        </ng-container>
        <!-- //[ヘッダー下メニュー ボタンエリア] -->

        <!-- [ステップナビゲーション] -->
        <div class="l-top-navi__progress-area">
          <ol class="l-top-navi__progress-list" [attr.aria-label]="'reader.breadcrumb.navigation' | staticMsg">
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active l-top-navi__progress-item--current">
              <div class="l-top-navi__progress-wrap">
                <span *ngIf="isPc" class="u-visually-hidden">{{ 'reader.breadcrumb.current' | staticMsg }}</span>
                <span *ngIf="isSp || isTb" class="u-visually-hidden">{{
                  'alt.stepBar' | staticMsg : { '0': this.stepNum, '1': this.currentStepNum }
                }}</span>
                <span class="l-top-navi__progress-num">{{ 'label.breadcrumb.first' | staticMsg }}</span>
                <span class="l-top-navi__progress-text">{{ 'label.flightSearch' | staticMsg }}</span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <em class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num">{{ 'label.breadcrumb.second' | staticMsg }}</span>
                <span class="l-top-navi__progress-text">{{ 'label.passengerInformationInput' | staticMsg }}</span>
              </em>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num">{{ 'label.breadcrumb.third' | staticMsg }}</span>
                <span class="l-top-navi__progress-text">{{ 'label.suchAsSeatAssign' | staticMsg }}</span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num">{{ 'label.breadcrumb.fourth' | staticMsg }}</span>
                <span class="l-top-navi__progress-text">{{ 'label.purchase2' | staticMsg }}</span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num">{{ 'label.breadcrumb.fifth' | staticMsg }}</span>
                <span class="l-top-navi__progress-text">{{ 'label.complete' | staticMsg }}</span>
              </div>
            </li>
          </ol>
        </div>
        <!-- //[ステップナビゲーション] -->

        <!-- [ヘッダー下メニュー ボタンエリア] -->
        <ng-container *ngIf="isPc">
          <div class="l-top-navi__function-area">
            <div class="l-top-navi__function-item" *ngIf="!loginStatus">
              <button
                id="search-flight-sub-header-button-5-2"
                class="l-top-navi__function-btn l-top-navi__function-btn--history"
                (throttleClick$)="clickHistory()"
                aswThrottleClick
              >
                <span class="u-visually-hidden" [innerHTML]="'label.searchHistory.title' | staticMsg"></span>
              </button>
            </div>
            <div class="l-top-navi__function-item" *ngIf="!loginStatus">
              <button
                id="search-flight-sub-header-button-6-2"
                class="l-top-navi__function-btn l-top-navi__function-btn--favorites"
                (throttleClick$)="clickFavorite()"
                aswThrottleClick
              >
                <span class="u-visually-hidden" [innerHTML]="'label.Favorite.title' | staticMsg"></span>
              </button>
            </div>
          </div>
        </ng-container>
        <!-- //[ヘッダー下メニュー ボタンエリア] -->
      </div>
    </div>
  </div>
</div>
